<p-toast position="bottom-center"></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

    <app-page-hero
        [eyebrow]="t('pages.companyShipments.hero.eyebrow', 'Operations')"
        [title]="t('pages.companyShipments.hero.title', 'Shipment Directory')"
        [subtitle]="t('pages.companyShipments.hero.subtitle', 'Monitor shipment orders owned by your company across booking, transit, fulfillment, and closure.')">
        <div actions>
            <p-button [label]="t('pages.companyShipments.hero.myShipments', 'My Shipments')" icon="pi pi-user" [severity]="showMyShipments ? 'info' : 'secondary'"
                [outlined]="!showMyShipments" (onClick)="toggleMyShipments()"></p-button>
            <p-button [label]="t('pages.companyShipments.hero.refresh', 'Refresh')" icon="pi pi-refresh" severity="secondary" [outlined]="true"
                (onClick)="refresh()"></p-button>
            <p-button [label]="t('pages.companyShipments.hero.exportExcel', 'Export Excel')" icon="pi pi-file-excel" severity="secondary" [outlined]="true"
                [loading]="isExporting" [pTooltip]="t('pages.companyShipments.hero.exportTooltip', 'Requires a scheduled date range of one month or less; exports up to 100 rows.')"
                (onClick)="exportExcel()"></p-button>
            <p-button *ngIf="permissionService.hasPermission(app_permissions.shipments.deliveries.view)"
                [label]="t('pages.companyShipments.hero.deliveryDirectory', 'Delivery Directory')" icon="pi pi-truck" severity="secondary" [outlined]="true"
                (onClick)="openDeliveryDirectory()"></p-button>
            <p-button *ngIf="permissionService.hasPermission(app_permissions.shipments.CREATE)"
                [label]="t('pages.companyShipments.hero.newShipment', 'New Shipment')" icon="pi pi-plus" (onClick)="createShipment()"></p-button>
        </div>
    </app-page-hero>

    <app-page-search-panel
        [title]="t('pages.companyShipments.search.title')"
        [activeFilters]="activeFilterCount()"
        [resultText]="resultText()"
        [collapsed]="true"
        (search)="applyFilters()"
        (clear)="clearFilters()">
        <div class="formgrid grid shipment-form-grid">
            <div class="col-12 directory-filter-heading"><i class="pi pi-hashtag"></i> {{ t('pages.companyShipments.search.references', 'References') }}</div>
            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input pInputText id="searchText" type="text" [(ngModel)]="searchText" [placeholder]="t('pages.companyShipments.search.keywordPlaceholder')">
                        <label for="searchText">{{ t('pages.companyShipments.search.keywordSearch') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input pInputText id="waybillNumber" type="text" [(ngModel)]="waybillNumber" placeholder="Waybill number">
                        <label for="waybillNumber">Waybill Number</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input pInputText id="shipmentNumber" type="text" [(ngModel)]="shipmentNumber" [placeholder]="t('pages.companyShipments.search.shipmentNumberPlaceholder')">
                        <label for="shipmentNumber">{{ t('pages.companyShipments.search.shipmentNumber') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-link"></i></p-inputGroupAddon><p-iftaLabel>
                    <input pInputText id="releaseNumber" [(ngModel)]="releaseNumber" placeholder="ORL/…">
                    <label for="releaseNumber">{{ t('pages.companyShipments.search.releaseNumber', 'Order Release Number') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-bookmark"></i></p-inputGroupAddon><p-iftaLabel>
                    <input pInputText id="referenceText" [(ngModel)]="referenceText" placeholder="External or customer order reference">
                    <label for="referenceText">{{ t('pages.companyShipments.search.referenceText', 'External / Customer Reference') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="col-12 directory-filter-heading"><i class="pi pi-users"></i> {{ t('pages.companyShipments.search.clientsProjects', 'Clients & Projects') }}</div>
            <div class="field col-12 md:col-3">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-multiSelect inputId="companyParty" [options]="legacyCompanyOptions" [(ngModel)]="legacyCompanies" optionLabel="label" optionValue="value" display="chip" [filter]="true" [showClear]="true" (onShow)="loadFilterOptions('legacyCompanies')" (onFilter)="loadFilterOptions('legacyCompanies', $event.filter)" styleClass="w-full"></p-multiSelect>
                        <label for="companyParty">{{ t('pages.companyShipments.search.legacyCompany', 'Legacy Company') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-3">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-multiSelect inputId="customerParty" [options]="legacyCustomerOptions" [(ngModel)]="legacyCustomers" optionLabel="label" optionValue="value" display="chip" [filter]="true" [showClear]="true" (onShow)="loadFilterOptions('legacyCustomers')" (onFilter)="loadFilterOptions('legacyCustomers', $event.filter)" styleClass="w-full"></p-multiSelect>
                        <label for="customerParty">{{ t('pages.companyShipments.search.legacyCustomer', 'Legacy Customer') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-3">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-multiSelect inputId="crmClients" [options]="crmClientOptions" [(ngModel)]="crmClients" optionLabel="label" optionValue="value" display="chip" [filter]="true" [showClear]="true" (onShow)="loadFilterOptions('crmClients')" (onFilter)="loadFilterOptions('crmClients', $event.filter)" styleClass="w-full"></p-multiSelect>
                    <label for="crmClients">{{ t('pages.companyShipments.search.crmClients', 'CRM Clients') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-3">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-multiSelect inputId="crmAccounts" [options]="crmAccountOptions" [(ngModel)]="crmAccounts" optionLabel="label" optionValue="value" display="chip" [filter]="true" [showClear]="true" (onShow)="loadFilterOptions('crmAccounts')" (onFilter)="loadFilterOptions('crmAccounts', $event.filter)" styleClass="w-full"></p-multiSelect>
                    <label for="crmAccounts">{{ t('pages.companyShipments.search.crmAccounts', 'CRM Accounts') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-3">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-address-book"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-multiSelect inputId="crmContacts" [options]="crmContactOptions" [(ngModel)]="crmContacts" optionLabel="label" optionValue="value" display="chip" [filter]="true" [showClear]="true" (onShow)="loadFilterOptions('crmContacts')" (onFilter)="loadFilterOptions('crmContacts', $event.filter)" styleClass="w-full"></p-multiSelect>
                    <label for="crmContacts">{{ t('pages.companyShipments.search.crmContacts', 'CRM Contacts') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-3">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-select inputId="logisticsProject" [options]="logisticsProjectOptions" [(ngModel)]="selectedLogisticsProject" optionLabel="projectName" [placeholder]="t('pages.companyShipments.search.selectProject')" [filter]="true" filterBy="projectName,projectNumber" [showClear]="true" (onShow)="loadLogisticsProjectOptions()" (onFilter)="loadLogisticsProjectOptions($event.filter)" styleClass="w-full">
                            <ng-template let-project pTemplate="item">
                                <div class="flex flex-column">
                                    <strong>{{ project.projectName }}</strong>
                                    <small>{{ project.projectNumber }}</small>
                                </div>
                            </ng-template>
                        </p-select>
                        <label for="logisticsProject">{{ t('pages.companyShipments.search.logisticsProject') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="col-12 directory-filter-heading"><i class="pi pi-map"></i> {{ t('pages.companyShipments.search.routeSchedule', 'Route & Schedule') }}</div>
            <div class="field col-12 md:col-3">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-select inputId="sourceLocation" appLazyLocationPicker [(ngModel)]="selectedSourceLocation" optionLabel="name" [placeholder]="t('pages.companyShipments.search.selectSource')" [filter]="true" filterBy="name,longDescription,shortDescription" [showClear]="true" styleClass="w-full"></p-select>
                        <label for="sourceLocation">{{ t('pages.companyShipments.search.sourceLocation') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-3">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-select inputId="destinationLocation" appLazyLocationPicker [(ngModel)]="selectedDestinationLocation" optionLabel="name" [placeholder]="t('pages.companyShipments.search.selectDestination')" [filter]="true" filterBy="name,longDescription,shortDescription" [showClear]="true" styleClass="w-full"></p-select>
                        <label for="destinationLocation">{{ t('pages.companyShipments.search.destinationLocation') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-3">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input pInputText id="pickupCity" type="text" [(ngModel)]="pickupCity" [placeholder]="t('pages.companyShipments.search.pickupCityPlaceholder')">
                        <label for="pickupCity">{{ t('pages.companyShipments.search.pickupCity') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-3">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input pInputText id="dropoffCity" type="text" [(ngModel)]="dropoffCity" [placeholder]="t('pages.companyShipments.search.dropoffCityPlaceholder')">
                        <label for="dropoffCity">{{ t('pages.companyShipments.search.dropoffCity') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-6">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-datePicker inputId="pickupDateRange" [(ngModel)]="pickupDateRange" selectionMode="range" [readonlyInput]="true" dateFormat="yy-mm-dd" appendTo="body" styleClass="w-full"></p-datePicker>
                        <label for="pickupDateRange">{{ t('pages.companyShipments.search.pickupDateRange') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-6">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-calendar-clock"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-datePicker inputId="dropoffDateRange" [(ngModel)]="dropoffDateRange" selectionMode="range" [readonlyInput]="true" dateFormat="yy-mm-dd" appendTo="body" styleClass="w-full"></p-datePicker>
                        <label for="dropoffDateRange">{{ t('pages.companyShipments.search.dropoffDateRange') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-6">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar-plus"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-datePicker inputId="createdDateRange" [(ngModel)]="createdDateRange" selectionMode="range" [readonlyInput]="true" dateFormat="yy-mm-dd" appendTo="body" styleClass="w-full"></p-datePicker>
                    <label for="createdDateRange">{{ t('pages.companyShipments.search.createdDateRange', 'Created Date Range') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="col-12 directory-filter-heading"><i class="pi pi-sliders-h"></i> {{ t('pages.companyShipments.search.operations', 'Operations') }}</div>
            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-info-circle"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-multiSelect
                            inputId="shipmentStatus"
                            [options]="statusOptions()"
                            [(ngModel)]="selectedStatuses"
                            [placeholder]="t('pages.companyShipments.search.selectStatus')"
                            optionLabel="label"
                            optionValue="value"
                            display="chip"
                            [selectedItemsLabel]="t('pages.companyShipments.search.statusesSelected')"
                            [showClear]="true"
                            appendTo="body"
                            styleClass="w-full">
                        </p-multiSelect>
                        <label for="shipmentStatus">{{ t('pages.companyShipments.search.status') }}</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-multiSelect inputId="shipmentDrivers" [options]="driverOptions" [(ngModel)]="drivers" optionLabel="label" optionValue="value" display="chip" [filter]="true" [showClear]="true" (onShow)="loadFilterOptions('drivers')" (onFilter)="loadFilterOptions('drivers', $event.filter)" styleClass="w-full"></p-multiSelect>
                    <label for="shipmentDrivers">{{ t('pages.companyShipments.search.drivers', 'Assigned Drivers') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-multiSelect inputId="shipmentVehicles" [options]="vehicleOptions" [(ngModel)]="vehicles" optionLabel="label" optionValue="value" display="chip" [filter]="true" [showClear]="true" (onShow)="loadFilterOptions('vehicles')" (onFilter)="loadFilterOptions('vehicles', $event.filter)" styleClass="w-full"></p-multiSelect>
                    <label for="shipmentVehicles">{{ t('pages.companyShipments.search.vehicles', 'Assigned Vehicles') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-user-plus"></i></p-inputGroupAddon><p-iftaLabel>
                    <p-select inputId="shipmentAssignment" [options]="[{label: 'Fully assigned', value: 'ASSIGNED'}, {label: 'Needs assignment', value: 'UNASSIGNED'}]" [(ngModel)]="assignmentState" optionLabel="label" optionValue="value" [showClear]="true" styleClass="w-full"></p-select>
                    <label for="shipmentAssignment">{{ t('pages.companyShipments.search.assignment', 'Assignment') }}</label>
                </p-iftaLabel></p-inputGroup>
            </div>
            <div class="field col-12 md:col-4 directory-check-field">
                <label><input type="checkbox" [(ngModel)]="includeClosed"> {{ t('pages.companyShipments.search.includeClosed', 'Include closed shipments') }}</label>
                <small *ngIf="!includeClosed">{{ t('pages.companyShipments.search.closedExcluded', 'Closed shipments are excluded by default.') }}</small>
            </div>
        </div>
    </app-page-search-panel>
    <div class="directory-default-note" *ngIf="closedShipmentsExcluded()">
        <i class="pi pi-info-circle"></i> {{ t('pages.companyShipments.search.closedExcluded', 'Closed shipments are excluded by default.') }}
    </div>
    <div class="directory-active-filters" *ngIf="appliedChips.length">
        <button type="button" class="directory-filter-chip" *ngFor="let chip of appliedChips" (click)="removeFilter(chip.key)" [attr.aria-label]="'Remove ' + chip.label">
            {{ chip.label }} <i class="pi pi-times"></i>
        </button>
    </div>

    <app-page-metric-strip [metrics]="shipmentMetrics()"></app-page-metric-strip>

    <app-page-data-panel
        [title]="t('pages.companyShipments.dataPanel.title')"
        subtitle="Customer context, route, load, fulfillment progress, and latest operational status in one view."
        [resultText]="resultText()">
        <p-table [value]="shipmentList" dataKey="shipmentId" [resizableColumns]="true" [rowHover]="true" [loading]="isLoading"
             styleClass="p-datatable-sm p-datatable-gridlines shipment-rich-table" [tableStyle]="{ 'min-width': '100rem' }"
             [paginator]="true" [rows]="pageSize" [first]="first" [showCurrentPageReport]="true"
             [totalRecords]="totalRecords" [lazy]="true"
             [sortField]="sortField" [sortOrder]="sortOrder"
             [currentPageReportTemplate]="currentPageReportTemplate()"
             (onLazyLoad)="loadShipmentList($event)" [rowsPerPageOptions]="[10, 25, 50]">
            <ng-template pTemplate="header">
                <tr>
                    <th class="shipment-action-col">{{ t('pages.companyShipments.table.actions', 'Actions') }}</th>
                    <th pSortableColumn="shipmentId" style="width: 18rem">
                        {{ t('pages.companyShipments.table.shipmentContext', 'Shipment & Context') }} <p-sortIcon field="shipmentId"></p-sortIcon>
                    </th>
                    <th style="width: 17rem">{{ t('pages.companyShipments.table.customerContact', 'Customer & Contact') }}</th>
                    <th style="width: 28rem">{{ t('pages.companyShipments.table.route', 'Route') }}</th>
                    <th pSortableColumn="requestedBookingTime" style="width: 21rem">
                        {{ t('pages.companyShipments.table.loadSchedule', 'Load & Schedule') }} <p-sortIcon field="requestedBookingTime"></p-sortIcon>
                    </th>
                    <th pSortableColumn="workflowUpdatedAt" style="width: 22rem">
                        {{ t('pages.companyShipments.table.fulfillmentStatus', 'Fulfillment & Latest Status') }} <p-sortIcon field="workflowUpdatedAt"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-shipment>
                <tr>
                    <td class="shipment-action-col">
                        <div class="shipment-row-actions">
                            <p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="info"
                                [pTooltip]="t('pages.companyShipments.table.viewSimpleOperations', 'Open simple operations view')" tooltipPosition="right"
                                (onClick)="viewDetailPage(shipment)"></p-button>
                            <p-button icon="pi pi-th-large" [rounded]="true" [text]="true" severity="secondary"
                                [pTooltip]="t('pages.companyShipments.table.viewAdvancedWorkspace', 'Open advanced workspace')" tooltipPosition="right"
                                (onClick)="viewAdvancedPage(shipment)"></p-button>
                        </div>
                    </td>
                    <td>
                        <div class="shipment-rich-stack">
                            <button type="button" class="shipment-link-button" (click)="viewDetailPage(shipment)">
                                {{shipment.shipmentNumber}}
                            </button>
                            <span class="shipment-cell-meta">{{ t('pages.companyShipments.table.id') }} {{shipment.shipmentId}}</span>
                            <div class="shipment-tag-row">
                                <p-tag [value]="statusLabel(displayShipmentStatus(shipment))"
                                    [severity]="getSeverity(displayShipmentStatus(shipment))"></p-tag>
                                <p-tag *ngIf="shipment.routeType" [value]="formatOperationalStatus(shipment.routeType)"
                                    severity="secondary"></p-tag>
                            </div>
                            <span><i class="pi pi-hashtag"></i>{{ shipmentContextReference(shipment) }}</span>
                            <span><i class="pi pi-briefcase"></i>{{ shipmentProjectLabel(shipment) }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="shipment-rich-stack">
                            <span class="shipment-cell-meta">CRM client</span>
                            <p-chip
                                [label]="shipment.crmClient?.name || shipment.customer?.name || '-'"
                                [image]="shipment.crmClient?.imageUrl || shipment.customer?.imageUrl">
                            </p-chip>
                            <span *ngIf="shipment.crmAccount?.name" class="shipment-cell-meta">
                                <i class="pi pi-building"></i> CRM account: {{ shipment.crmAccount?.name }}
                            </span>
                            <span *ngIf="shipment.crmClient?.name && !shipment.crmAccount?.name && shipment.customer?.name"
                                  class="shipment-cell-meta">
                                <i class="pi pi-sitemap"></i> Sub-party: {{ shipment.customer?.name }}
                            </span>
                            <span *ngIf="shipment.crmClientContact?.name" class="shipment-cell-meta">
                                <i class="pi pi-user"></i> CRM contact: {{ shipment.crmClientContact?.name }}
                            </span>
                            <span *ngIf="shipment.createdBy?.name" class="shipment-cell-meta">
                                <i class="pi pi-user-plus"></i> Created by {{ shipment.createdBy?.name }}
                            </span>
                            <span *ngIf="shipment.updatedBy?.name" class="shipment-cell-meta">
                                <i class="pi pi-user-edit"></i> Updated by {{ shipment.updatedBy?.name }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="shipment-route-flow">
                            <div class="shipment-route-point pickup">
                                <span class="route-marker"><i class="pi pi-map-marker"></i></span>
                                <div>
                                    <span class="shipment-cell-meta">{{ t('pages.companyShipments.table.pickup') }}</span>
                                    <strong>{{shipment.sourceLocation?.name || shipment.pickupCity || '-'}}</strong>
                                    <small>{{ getLocationShortAddress(shipment.sourceLocation?.address) || shipment.pickupCity || '' }}</small>
                                </div>
                            </div>
                            <div class="shipment-route-line"></div>
                            <div class="shipment-route-point dropoff">
                                <span class="route-marker"><i class="pi pi-flag"></i></span>
                                <div>
                                    <span class="shipment-cell-meta">{{ t('pages.companyShipments.table.dropoff') }}</span>
                                    <strong>{{shipment.destinationLocation?.name || shipment.dropoffCity || '-'}}</strong>
                                    <small>{{ getLocationShortAddress(shipment.destinationLocation?.address) || shipment.dropoffCity || '' }}</small>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="shipment-rich-stack">
                            <strong><i class="pi pi-truck"></i>{{shipment.quantityRequired || 0}}
                                {{ t('pages.companyShipments.table.trucks', { count: shipment.quantityRequired || 0 }) }}</strong>
                            <span>{{ shipment.equipmentLabel || 'Equipment pending' }}</span>
                            <span><i class="pi pi-box"></i>{{ shipmentCargoSummary(shipment) }}</span>
                            <span><i class="pi pi-calendar-clock"></i>{{ shipment.requestedBookingTime ? showDate(shipment.requestedBookingTime) : 'Schedule pending' }}</span>
                            <div class="shipment-tag-row">
                                <p-tag *ngIf="shipment.serviceCategory" [value]="formatOperationalStatus(shipment.serviceCategory)"
                                    severity="info"></p-tag>
                                <p-tag *ngIf="shipment.requestedBookingOption"
                                    [value]="formatOperationalStatus(shipment.requestedBookingOption)" severity="secondary"></p-tag>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="shipment-rich-stack">
                            <div class="shipment-progress-header">
                                <span>Delivery progress</span>
                                <strong>{{ shipmentProgress(shipment) }}%</strong>
                            </div>
                            <p-progressBar [value]="shipmentProgress(shipment)" [showValue]="false"
                                styleClass="shipment-directory-progress"></p-progressBar>
                            <span class="shipment-cell-meta">{{ shipmentProgressCaption(shipment) }}</span>
                            <div class="shipment-tag-row">
                                <p-tag [value]="formatOperationalStatus(latestDeliveryStatus(shipment))"
                                    [severity]="deliveryStatusSeverity(latestDeliveryStatus(shipment))"></p-tag>
                                <p-tag [value]="shipmentDeliveryCount(shipment) + ' deliveries'" severity="secondary"></p-tag>
                            </div>
                            <span><i class="pi pi-clock"></i>Updated:
                                {{ latestOperationalUpdate(shipment) ? showDate(latestOperationalUpdate(shipment)!) : '-' }}</span>
                            <span><i class="pi pi-paperclip"></i>{{ shipment.fileCount || 0 }} shipment files</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">
                        <div class="shipment-empty-state">
                            <i class="pi pi-search"></i>
                            <strong>{{ t('pages.companyShipments.empty.title') }}</strong>
                            <span>{{ t('pages.companyShipments.empty.subtitle') }}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
